import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../helpers/export'
import FinanceService from './services/FinanceService'
import IndustryService from './services/IndustryService'

export const getReportYear = createAsyncThunk(
  'portfolioInsights/finance/getReportYear',
  async (data, { rejectWithValue }) => {
    try {
      const response = await IndustryService.getReportYear(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postTotalCompany = createAsyncThunk(
  'portfolioInsights/finance/postTotalCompany',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postTotalCompany(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postHightLight = createAsyncThunk(
  'portfolioInsights/finance/postHightLight',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postHightLight(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postOrganizationInfo = createAsyncThunk(
  'portfolioInsights/finance/postOrganizationInfo',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postOrganizationInfo(data)
      if (response.success) {
        return response
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postLiquiditySolvencyAndCoverage = createAsyncThunk(
  'portfolioInsights/finance/postLiquiditySolvencyAndCoverage',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postLiquiditySolvencyAndCoverage(
        data,
      )
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postAssetManagementEfficiency = createAsyncThunk(
  'portfolioInsights/finance/postAssetManagementEfficiency',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postAssetManagementEfficiency(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postProfitability = createAsyncThunk(
  'portfolioInsights/finance/postProfitability',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postProfitability(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postBusinessGrowth = createAsyncThunk(
  'portfolioInsights/finance/postBusinessGrowth',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postBusinessGrowth(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postCapitalAdequacy = createAsyncThunk(
  'portfolioInsights/finance/postCapitalAdequacy',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postCapitalAdequacy(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postAssetQuality = createAsyncThunk(
  'portfolioInsights/finance/postAssetQuality',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postAssetQuality(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postEarningsQuality = createAsyncThunk(
  'portfolioInsights/finance/postEarningsQuality',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postEarningsQuality(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postFundingLiquidity = createAsyncThunk(
  'portfolioInsights/finance/postFundingLiquidity',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postFundingLiquidity(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postBusinessPosition = createAsyncThunk(
  'portfolioInsights/finance/postBusinessPosition',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postBusinessPosition(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postCapitalEarningLeverage = createAsyncThunk(
  'portfolioInsights/finance/postCapitalEarningLeverage',
  async (data, { rejectWithValue }) => {
    try {
      const response = await FinanceService.postCapitalEarningLeverage(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportLiquiditySolvencyAndCoverage = createAsyncThunk(
  'portfolioInsights/finance/exportLiquiditySolvencyAndCoverage',
  async (params) => {
    const response = await FinanceService.exportLiquiditySolvencyAndCoverage(
      params,
    )
    handleExport(response.data, response.filename)
  },
)

export const exportAssetManagementEfficiency = createAsyncThunk(
  'portfolioInsights/finance/exportAssetManagementEfficiency',
  async (params) => {
    const response = await FinanceService.exportAssetManagementEfficiency(
      params,
    )
    handleExport(response.data, response.filename)
  },
)

export const exportProfitability = createAsyncThunk(
  'portfolioInsights/finance/exportProfitability',
  async (params) => {
    const response = await FinanceService.exportProfitability(params)
    handleExport(response.data, response.filename)
  },
)

export const exportBusinessGrowth = createAsyncThunk(
  'portfolioInsights/finance/exportBusinessGrowth',
  async (params) => {
    const response = await FinanceService.exportBusinessGrowth(params)
    handleExport(response.data, response.filename)
  },
)

export const exportCapitalAdequacy = createAsyncThunk(
  'portfolioInsights/finance/exportCapitalAdequacy',
  async (params) => {
    const response = await FinanceService.exportCapitalAdequacy(params)
    handleExport(response.data, response.filename)
  },
)

export const exportAssetQuality = createAsyncThunk(
  'portfolioInsights/finance/exportAssetQuality',
  async (params) => {
    const response = await FinanceService.exportAssetQuality(params)
    handleExport(response.data, response.filename)
  },
)

export const exportEarningsQuality = createAsyncThunk(
  'portfolioInsights/finance/exportEarningsQuality',
  async (params) => {
    const response = await FinanceService.exportEarningsQuality(params)
    handleExport(response.data, response.filename)
  },
)

export const exportFundingLiquidity = createAsyncThunk(
  'portfolioInsights/finance/exportFundingLiquidity',
  async (params) => {
    const response = await FinanceService.exportFundingLiquidity(params)
    handleExport(response.data, response.filename)
  },
)

export const exportSecuritiesBusinessPosition = createAsyncThunk(
  'portfolioInsights/finance/exportSecuritiesBusinessPosition',
  async (params) => {
    const response = await FinanceService.exportSecuritiesBusinessPosition(
      params,
    )
    handleExport(response.data, response.filename)
  },
)

export const exportCapitalEarningLeverage = createAsyncThunk(
  'portfolioInsights/finance/exportCapitalEarningLeverage',
  async (params) => {
    const response = await FinanceService.exportCapitalEarningLeverage(params)
    handleExport(response.data, response.filename)
  },
)
